export default __webpack_public_path__ + "static/Gotham-Medium-b9ff5df509cde211ce4627bcfab81685.woff";